import * as actions from "./terminatedLoansActions";
import * as fileActions from "./terminationFileActions";
import _ from "underscore";
import update from "immutability-helper";

export let initialState = {
  fetching: false,
  fetched: false,
  error: null,
  sellingId: null,
  sellingError: null,
  lastSoldId: null,
  data: [],

  filesCreate: {
    sending: false,
    send: false,
    error: undefined,
  },

  fileLoad: {
    fetching: false,
    fetched: false,
    data: [],
    error: null,
  },
};

export let terminatedCollectionLoans = (state = initialState, action) => {
  switch (action.type) {
    case actions.COLLECTION_TERMINATED_LOANS_FETCH_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
      });
    case actions.COLLECTION_TERMINATED_LOANS_FETCH_SUCCESS: {
      let filteredLoans = _.filter(action.response, (item) => {
        return item !== null;
      });

      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data: filteredLoans,
      });
    }
    case actions.COLLECTION_TERMINATED_LOANS_FETCH_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: action.error,
      });

    ///////////// dca files

    case fileActions.COLLECTION_CREATE_FILES_REQUEST: {
      return Object.assign({}, state, {
        filesCreate: Object.assign({}, state.filesCreate, { sending: true }),
      });
    }

    case fileActions.COLLECTION_CREATE_FILES_SUCCESS: {
      return Object.assign({}, state, {
        filesCreate: Object.assign({}, state.filesCreate, {
          sending: false,
          send: true,
        }),
      });
    }

    case fileActions.COLLECTION_CREATE_FILES_ERROR: {
      return Object.assign({}, state, {
        filesCreate: Object.assign({}, state.filesCreate, {
          sending: false,
          error: action.error,
        }),
      });
    }

    case fileActions.COLLECTION_FILES_REQUEST: {
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, { fetching: true }),
      });
    }

    case fileActions.COLLECTION_FILES_SUCCESS: {
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    }

    case fileActions.COLLECTION_FILES_ERROR: {
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, {
          fetching: false,
          error: action.error,
        }),
      });
    }

    case fileActions.COLLECTION_LOAD_FILE_DETAILS_REQUEST: {
      const data = state.fileLoad.data;
      const index = _.findIndex(
        data,
        (file) => file.Id === action.dataSent.BatchId,
      );
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, {
          data: [
            ...data.slice(0, index),
            Object.assign({}, data[index], {
              details: {
                fetching: true,
                fetched: false,
                data: [],
                error: null,
              },
            }),
            ...data.slice(index + 1),
          ],
        }),
      });
    }

    case fileActions.COLLECTION_LOAD_FILE_DETAILS_SUCCESS: {
      const data = state.fileLoad.data;
      const index = _.findIndex(
        data,
        (file) => file.Id === action.dataSent.BatchId,
      );
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, {
          data: [
            ...data.slice(0, index),
            Object.assign({}, data[index], {
              details: {
                fetching: false,
                fetched: true,
                data: action.response,
                error: null,
              },
            }),
            ...data.slice(index + 1),
          ],
        }),
      });
    }

    case fileActions.COLLECTION_LOAD_FILE_DETAILS_ERROR: {
      const data = state.fileLoad.data;
      const index = _.findIndex(
        data,
        (file) => file.Id === action.dataSent.BatchId,
      );
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, {
          data: [
            ...data.slice(0, index),
            Object.assign({}, data[index], {
              details: {
                fetching: false,
                fetched: false,
                data: [],
                error: action.error,
              },
            }),
            ...data.slice(index + 1),
          ],
        }),
      });
    }

    case fileActions.COLLECTION_FINALIZE_FILE_REQUEST: {
      const data = state.fileLoad.data;
      const index = _.findIndex(
        data,
        (file) => file.Id === action.dataSent.BatchId,
      );
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, {
          data: [
            ...data.slice(0, index),
            Object.assign({}, data[index], {
              FinalizedChangeRequest: true,
              FinalizedChangeError: undefined,
            }),
            ...data.slice(index + 1),
          ],
        }),
      });
    }

    case fileActions.COLLECTION_FINALIZE_FILE_SUCCESS: {
      const data = state.fileLoad.data;
      const index = _.findIndex(
        data,
        (file) => file.Id === action.dataSent.BatchId,
      );
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, {
          data: [
            ...data.slice(0, index),
            Object.assign({}, data[index], {
              FinalizedChangeRequest: undefined,
              Finalized: true,
            }),
            ...data.slice(index + 1),
          ],
        }),
      });
    }

    case fileActions.COLLECTION_FINALIZE_FILE_ERROR: {
      const data = state.fileLoad.data;
      const index = _.findIndex(
        data,
        (file) => file.Id === action.dataSent.BatchId,
      );
      return Object.assign({}, state, {
        fileLoad: Object.assign({}, state.fileLoad, {
          data: [
            ...data.slice(0, index),
            Object.assign({}, data[index], {
              FinalizedChangeRequest: undefined,
              FinalizedChangeError: action.error,
            }),
            ...data.slice(index + 1),
          ],
        }),
      });
    }

    case fileActions.COLLECTION_REMOVE_LOAN_FROM_FILE_SUCCESS: {
      const data = state.fileLoad.data;
      const index = _.findIndex(
        data,
        (file) => file.Id === action.dataSent.BatchId,
      );

      const loans = _.filter(data[index].details.data.Loans, (loan) => {
        return loan.LoanId !== action.dataSent.LoanId;
      });

      return update(state, {
        fileLoad: {
          data: {
            [index]: (item) =>
              update(item, {
                details: {
                  data: {
                    Loans: { $set: loans },
                  },
                },
              }),
          },
        },
      });
    }

    default:
      return state;
  }
};
